export default __webpack_public_path__ + "static/youtube-25b78da997698a346721747feb6fd1b9.svg";